<div class="tabbable__body rounded-top-right no-margin">
  <h3>
    Här kan du administrera tillgängliga apparater
  </h3>

  @if (show.estimatesHaveChanged) {
    <import-warning></import-warning>
  }
  <form #shareOfTotalForm="ngForm">
    <div class="container">
      <div class="left-item">
        <button
          class="button primary-1"
          (click)="showNewDeviceGroup()"
          [scrollTo]="newDeviceGroupFormContainer"
        >
          Ny apparat
        </button>
        @if (show.isEditing) {
          <button
            class="button primary"
            (click)="save()"
            [disabled]="deviceGroupsForm.invalid || savingTableEdit()"
          >
            Spara
          </button>
          <button class="link" (click)="cancelEditing()">
            Avbryt redigering
          </button>
        } @else {
          <button
            class="button secondary"
            (click)="setEditing(true)"
          >
            Redigera apparater
          </button>
        }
      </div>

      <div class="right-item">
        <div class="dropdown filter-dropdown">
          <woo-dropdown
            [items]="deviceGroups()"
            [(ngModel)]="selectedDeviceGroup"
            name="selectedDeviceGroup()"
            inputId="select-deviceGroup"
            labelText="Filtrera på apparat"
            notFoundText="Inga val hittades."
            [clearable]="true"
          ></woo-dropdown>
        </div>

        @if (productFormats()?.length > 1) {
          <div class="dropdown filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="productFormats()"
              [(ngModel)]="selectedProductFormat"
              name="selectedProductFormat()"
              inputId="select-product-format"
              labelText="Filtrera på Placering"
              [labelTransform]="translateProductFormat"
              notFoundText="Inga Placeringar hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }

        @if (publishers()?.length > 1) {
          <div class="dropdown filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="publishers"
              [(ngModel)]="selectedPublisher"
              name="selectedPublisher()"
              inputId="select-publisher"
              labelText="Filtrera på Publicist"
              notFoundText="Inga publicister hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }
      </div>
    </div>
  </form>
  <div class="sticky-header">
    <h3>Tillgängliga apparater</h3>
  </div>

  <table
    class="table table-woo table--info table--hover width--100"
    ngForm
    #deviceGroupsForm="ngForm"
  >
    <thead class="sticky-table-head">
      <tr>
        <th [colSpan]="staticFields"></th>
        <th class="text-center" colspan="3">Estimatfördelning</th>
        <th class="text-center" colspan="3">Maxuttag</th>
        <th [colSpan]="1"></th>
      </tr>
      <tr>
        @for (header of tableHeaders; let i = $index; track i) {
          <th class="text--thin capitalize--first-letter">
            {{ header }}
          </th>
        }
      </tr>
    </thead>

    @if (!show.loading) {
      <tbody>
        @for (row of deviceRows(); let index = $index; track $index) {
          <tr [hidden]="!rowVisible(row)">
            <td class="text--thin vertical-align--middle">
              <span>{{ row.device }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ translateProductFormat(row.productFormat) }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ row.publisher }}</span>
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.sharesPreroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-sharesPreroll"
                    [(ngModel)]="getDeviceGroup(row.deviceId).shares[row.publisherId][row.productFormatId].preroll"
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="includedProductFormatSlotTypes()[row.productFormatId].preroll"
                    [disabled]="!includedProductFormatSlotTypes()[row.productFormatId].preroll"
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.sharesMidroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-sharesMidroll"
                    [(ngModel)]="getDeviceGroup(row.deviceId).shares[row.publisherId][row.productFormatId].midroll"
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="includedProductFormatSlotTypes()[row.productFormatId].midroll"
                    [disabled]="!includedProductFormatSlotTypes()[row.productFormatId].midroll"
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.sharesPostroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-sharesPostroll"
                    [(ngModel)]="getDeviceGroup(row.deviceId).shares[row.publisherId][row.productFormatId].postroll"
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="includedProductFormatSlotTypes()[row.productFormatId].postroll"
                    [disabled]="!includedProductFormatSlotTypes()[row.productFormatId].postroll"
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.withdrawalLimitsPreroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-withdrawalLimitsPreroll"
                    [(ngModel)]="getDeviceGroup(row.deviceId).withdrawal_limits[row.publisherId][row.productFormatId].preroll"
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="includedProductFormatSlotTypes()[row.productFormatId].preroll"
                    [disabled]="!includedProductFormatSlotTypes()[row.productFormatId].preroll"
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.withdrawalLimitsMidroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-withdrawalLimitsMidroll"
                    [(ngModel)]="getDeviceGroup(row.deviceId).withdrawal_limits[row.publisherId][row.productFormatId].midroll"
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="includedProductFormatSlotTypes()[row.productFormatId].midroll"
                    [disabled]="!includedProductFormatSlotTypes()[row.productFormatId].midroll"
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.withdrawalLimitsPostroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-withdrawalLimitsPostroll"
                    [(ngModel)]="getDeviceGroup(row.deviceId).withdrawal_limits[row.publisherId][row.productFormatId].postroll"
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="includedProductFormatSlotTypes()[row.productFormatId].postroll"
                    [disabled]="!includedProductFormatSlotTypes()[row.productFormatId].postroll"
                  />
                </div>
              }
            </td>

            <td class="padding-top-bottom--1x">
              <button
                [routerLink]="['/device_groups', row.deviceId]"
                class="status-badge primary float--left"
              >
                <span class="icon-edit icon__semi-medium"></span>
              </button>
            </td>
          </tr>
        }
      </tbody>
    }

    @if (show.isEditing) {
      <div class="margin-top--2x">
        <button
          class="button primary"
          (click)="save()"
          [disabled]="deviceGroupsForm.invalid || savingTableEdit()"
        >
          Spara
        </button>
        <button class="link" (click)="cancelEditing()">Avbryt redigering</button>
      </div>
    }
  </table>
  
  <dot-loader [visibility]="show.loading" [large]="true"></dot-loader>

  <div #newDeviceGroupFormContainer>
    @if (show.newDeviceGroupForm) {
      <div class="sub-card col-12">
        <h3>Ny apparat</h3>
          <device-group-form
            (onAbort)="hideNewDeviceGroup()"
            (onSubmit)="addDeviceGroup($event)"
          ></device-group-form>
      </div>
    }
  </div>
</div>

